import React from 'react';
import Header from './components/Header';
import MainContent from './views/MainContent';
import Footer from './components/Footer';
import styles from './index.module.css';
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import RatePlayer from './views/RatePlayer/RatePlayer';
import {fetchSquad} from './components/shared/api';
import Navbar from './components/shared/Navbar';
import { ThemeProvider } from '@mui/material/styles';
import theme from './components/shared/theme';
import QuickGame from './views/QuickGame/QuickGame';

const App = () => {

  const ratePlayer = (playerId: number, rating: number) => {
    return new Promise((resolve, reject) => {
      try {
        const playerRatings = JSON.parse(localStorage.getItem('playerRatings') || '{}');
        playerRatings[playerId] = rating;
        localStorage.setItem('playerRatings', JSON.stringify(playerRatings));
        resolve(playerRatings);
      } catch (error) {
        reject(error);
      }
    });
  };

  const updatePlayerRating = async (playerId: number, rating: number, squadId: number) => {
    console.log(`Updating player ${playerId} rating to ${rating} in squad ${squadId}`); // Add this line
    const response = await fetch(`/squads/${squadId}/players/${playerId}/rate`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ rating }),
    });
  
    if (!response.ok) {
      throw new Error(`Failed to rate player: ${response.statusText} with player ${playerId} rating to ${rating} in squad ${squadId}`);
    }
    const updatedPlayer = await response.json();
    console.log('Updated player:', updatedPlayer); // Add this line
    return updatedPlayer;
  };

  return (
    <ThemeProvider theme={theme}>
      <Router>
        <div className={styles.container}>
          <Header />
          <Navbar/>
          <Routes>
            <Route path="/" element={<Navigate to="/rate" replace />} />
            <Route path="/home" element={<MainContent updatePlayerRating={updatePlayerRating} ratePlayer={ratePlayer} />} />
            <Route path="/rate" element={<RatePlayer fetchSquad={fetchSquad} ratePlayer={ratePlayer} updatePlayerRating={updatePlayerRating}/>} />
            <Route path="/quickgame" element={<QuickGame/>}/>
          </Routes>
          <Footer />
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
